/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalid_Email_Case_ErrorInputs */

const en_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please use only lowercase letters.`)
};

const id_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harap gunakan hanya huruf kecil.`)
};

const ms_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sila gunakan huruf kecil sahaja.`)
};

const ca_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fes servir només lletres minúscules.`)
};

const cs_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Používejte prosím pouze malá písmena.`)
};

const da_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brug venligst kun små bogstaver.`)
};

const de_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte verwende nur Kleinbuchstaben.`)
};

const et_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasuta ainult väiketähti.`)
};

const es_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa solamente letras minúsculas.`)
};

const fr_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez utiliser uniquement des lettres minuscules.`)
};

const hr_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molimo koristite samo mala slova.`)
};

const it_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa solo lettere minuscole.`)
};

const lv_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lūdzu, izmantojiet tikai mazos burtus.`)
};

const lt_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naudokite tik mažąsias raides.`)
};

const hu_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kérjük, csak kisbetűket használj.`)
};

const nl_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik alleen kleine letters.`)
};

const nb_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vennligst bruk kun små bokstaver.`)
};

const pl_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proszę używać tylko małych liter.`)
};

const pt_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use apenas letras minúsculas.`)
};

const ro_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te rugăm să folosești doar litere mici.`)
};

const sk_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použite iba malé písmená.`)
};

const sl_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uporabite samo male črke.`)
};

const fi_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytä vain pieniä kirjaimia.`)
};

const sv_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Använd endast gemener.`)
};

const vi_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chỉ sử dụng chữ thường.`)
};

const tr_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen yalnızca küçük harf kullanın.`)
};

const el_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παρακαλούμε χρησιμοποιήστε μόνο πεζά γράμματα.`)
};

const bg_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моля, използвайте само малки букви.`)
};

const ru_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, используйте только строчные буквы.`)
};

const sr_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Користите само мала слова.`)
};

const uk_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Використовуйте лише малі літери.`)
};

const ka_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გთხოვთ, გამოიყენოთ მხოლოდ პატარა ასოები.`)
};

const hi_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया केवल लोअरकेस अक्षरों का उपयोग करें।`)
};

const th_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดใช้ตัวอักษรพิมพ์เล็กเท่านั้น`)
};

const ko_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소문자만 사용해 주세요.`)
};

const zh_tw_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請僅使用小寫字母。`)
};

const ja_invalid_email_case_error = /** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小文字のみを使用してください。`)
};

/** @type {(inputs: Invalid_Email_Case_ErrorInputs) => LocalizedString} */
const zh_invalid_email_case_error = en_invalid_email_case_error;

/**
* | output |
* | --- |
* | "Please use only lowercase letters." |
*
* @param {Invalid_Email_Case_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const invalid_email_case_error = /** @type {((inputs?: Invalid_Email_Case_ErrorInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalid_Email_Case_ErrorInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_invalid_email_case_error(inputs)
	if (locale === "ms") return ms_invalid_email_case_error(inputs)
	if (locale === "ca") return ca_invalid_email_case_error(inputs)
	if (locale === "cs") return cs_invalid_email_case_error(inputs)
	if (locale === "da") return da_invalid_email_case_error(inputs)
	if (locale === "de") return de_invalid_email_case_error(inputs)
	if (locale === "et") return et_invalid_email_case_error(inputs)
	if (locale === "es") return es_invalid_email_case_error(inputs)
	if (locale === "fr") return fr_invalid_email_case_error(inputs)
	if (locale === "hr") return hr_invalid_email_case_error(inputs)
	if (locale === "it") return it_invalid_email_case_error(inputs)
	if (locale === "lv") return lv_invalid_email_case_error(inputs)
	if (locale === "lt") return lt_invalid_email_case_error(inputs)
	if (locale === "hu") return hu_invalid_email_case_error(inputs)
	if (locale === "nl") return nl_invalid_email_case_error(inputs)
	if (locale === "nb") return nb_invalid_email_case_error(inputs)
	if (locale === "pl") return pl_invalid_email_case_error(inputs)
	if (locale === "pt") return pt_invalid_email_case_error(inputs)
	if (locale === "ro") return ro_invalid_email_case_error(inputs)
	if (locale === "sk") return sk_invalid_email_case_error(inputs)
	if (locale === "sl") return sl_invalid_email_case_error(inputs)
	if (locale === "fi") return fi_invalid_email_case_error(inputs)
	if (locale === "sv") return sv_invalid_email_case_error(inputs)
	if (locale === "vi") return vi_invalid_email_case_error(inputs)
	if (locale === "tr") return tr_invalid_email_case_error(inputs)
	if (locale === "el") return el_invalid_email_case_error(inputs)
	if (locale === "bg") return bg_invalid_email_case_error(inputs)
	if (locale === "ru") return ru_invalid_email_case_error(inputs)
	if (locale === "sr") return sr_invalid_email_case_error(inputs)
	if (locale === "uk") return uk_invalid_email_case_error(inputs)
	if (locale === "ka") return ka_invalid_email_case_error(inputs)
	if (locale === "hi") return hi_invalid_email_case_error(inputs)
	if (locale === "th") return th_invalid_email_case_error(inputs)
	if (locale === "ko") return ko_invalid_email_case_error(inputs)
	if (locale === "zh") return zh_invalid_email_case_error(inputs)
	if (locale === "zh-tw") return zh_tw_invalid_email_case_error(inputs)
	if (locale === "ja") return ja_invalid_email_case_error(inputs)
	return en_invalid_email_case_error(inputs)
});